<template>
  <div class="container mx-auto">
    <main class="main">
      <div class="partners_head">
        <h1>メディア掲載ページ</h1>
        <p>社内SE転職ナビを取り上げて頂いたメディア様を紹介致します。</p>
      </div>
      <PartnersListItem />
    </main>
  </div>
</template>

<script setup>
import PartnersListItem from '../components/PartnersListItem.vue';
import { computed } from 'vue';
import { useHead } from '@unhead/vue';

const title = computed(() => {
  return 'メディア掲載ページ｜社内SE・情報システムの転職・求人サイト｜【公式】社内SE転職ナビ';
});

const description = computed(() => {
  return '社内SEに特化したキャリア支援サービス「社内SE転職ナビ」の掲載メディアを紹介するページです。';
});

const keywords = computed(() => {
  return 'IT,エンジニア,求人,転職,情報システム,転職支援,社内SE転職,求人紹介, 転職サポート,ダイレクト求人, 直接オファー, 企業スカウト';
});

const url = computed(() => {
  return window.location.origin + '/partners';
});

useHead({
  title,
  meta: [
    {
      name: 'description',
      content: description,
    },
    {
      name: 'keywords',
      content: keywords,
    },
    {
      property: 'og:site_name',
      content: '社内SE転職ナビ',
    },
    {
      property: 'og:image',
      content: 'https://se-navi.jp/ogp_se.png',
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:description',
      content: description,
    },
    {
      property: 'og:url',
      content: url,
    },
    {
      property: 'twitter:image',
      content: 'https://se-navi.jp/ogp_se.png',
    },
    {
      name: 'twitter:title',
      content: title,
    },
    {
      name: 'twitter:description',
      content: description,
    },
  ],
});
</script>

<style scoped>
.partners_head {
  padding-top: 8px;
  :is(h1) {
    font-size: 32px;
    font-weight: bold;
  }
  :is(p) {
    font-size: 14px;
  }
  @media screen and (min-width: 768px) {
    padding: 24px 0 32px;
    :is(h1) {
      font-size: 32px;
    }
    :is(p) {
      font-size: 16px;
    }
  }
}
</style>
